import { Alert, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import type { ConversaoPrincipal } from '../api/conversoes'
import type { Marca } from '../state/FiltrosContext'
import { useAuth } from '../state/AuthContext'

const lista = (nomes: string[]) =>
  nomes.length <= 1 ? nomes.join('') : `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`

/**
 * Explica por que as conversões de um painel podem aparecer zeradas: a marca não tem
 * conversão principal, ou a principal dela não tem nenhuma ação da fonte deste painel
 * (ex.: "Vendas" montada só com o pixel do Meta dá zero no orgânico).
 */
export function AvisoConversao({
  marcas,
  principais,
  plataformasDaFonte,
  nomeDaFonte,
}: {
  /** Marcas no recorte do painel. */
  marcas: Marca[]
  principais: ConversaoPrincipal[]
  plataformasDaFonte: string[]
  /** Ex.: "do Meta Ads ou do Google Ads", "do GA4" */
  nomeDaFonte: string
}) {
  const { pode } = useAuth()
  const semPrincipal: string[] = []
  const semFonte: string[] = []
  for (const m of marcas) {
    const p = principais.find((x) => x.marcaId === m.id)
    if (!p) semPrincipal.push(m.nome)
    else if (!plataformasDaFonte.some((pl) => p.plataformas.has(pl))) semFonte.push(`${m.nome} ("${p.nome}")`)
  }
  if (!semPrincipal.length && !semFonte.length) return null
  const podeConfigurar = pode('conversoes.gerenciar')

  return (
    <Alert
      severity="info"
      action={
        podeConfigurar ? (
          <Button component={RouterLink} to="/configuracoes/conversoes" color="inherit" size="small" sx={{ textTransform: 'none', fontWeight: 700 }}>
            Configurar
          </Button>
        ) : undefined
      }
    >
      {semPrincipal.length ? `Sem conversão principal definida: ${lista(semPrincipal)}. ` : ''}
      {semFonte.length ? `A conversão principal de ${lista(semFonte)} não inclui nenhuma ação ${nomeDaFonte}. ` : ''}
      Nesses casos as conversões aparecem como zero.
      {podeConfigurar ? '' : ' Peça a um administrador para configurar.'}
    </Alert>
  )
}
